document.addEventListener('DOMContentLoaded', function() {
  // SVGの表示設定を初期化
  document.querySelectorAll('._underline svg').forEach(svg => {
    svg.style.visibility = 'visible';
    svg.style.opacity = 1;
  });

  document.querySelectorAll('.list-menu li').forEach(list => {
    const squiggle = list.querySelector('.squiggle');
    if (!squiggle) return;

    const length = squiggle.getTotalLength();
    squiggle.style.strokeDasharray = length;
    squiggle.style.strokeDashoffset = length;

    list.addEventListener('mouseover', function() {
      squiggle.style.animation = 'squiggleHoverAnimation 0.4s forwards ease-in-out';
    });

    list.addEventListener('mouseout', function() {
      squiggle.style.animation = 'none';
      setTimeout(() => {
        squiggle.style.strokeDashoffset = length;
      }, 0);
    });
    
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const details = document.querySelector('details');
    const menuIcon = document.getElementById('menuIcon');
  
    details.addEventListener('toggle', function() {
      if (details.open) {
        menuIcon.classList.add('open');
      } else {
        menuIcon.classList.remove('open');
      }
    });
  });
